import React from 'react';
import { Checkbox } from '@integrations/pint-ui-components';
import Icon from '../../common/Icon';
import { CoEditingSettings } from './interfaces';

interface DesktopAppDefaultsProps {
    coEditingSettings: CoEditingSettings;
    setCoEditingSettings: (settings: CoEditingSettings) => void;
}

export const DesktopAppDefaults = ({ coEditingSettings, setCoEditingSettings }: DesktopAppDefaultsProps) => (
    <div className="co-editing-defaults">
        <h3>Co-editing defaults for the Egnyte Desktop app</h3>
        <p>
            Define a default behavior for the cases when user double clicks on Microsoft Office files in Egnyte Desktop
            app
        </p>

        <div className="settings-group">
            <div className="setting-row">
                <label>Microsoft Word</label>
                <select
                    value={coEditingSettings.word}
                    onChange={(e) =>
                        setCoEditingSettings({
                            ...coEditingSettings,
                            word: e.target.value as CoEditingSettings['word'],
                        })
                    }
                >
                    <option>Start co-editing automatically</option>
                    <option>Ask the user</option>
                    <option>Open file without starting co-editing</option>
                </select>
            </div>

            <div className="setting-row">
                <label>Microsoft Excel</label>
                <select
                    value={coEditingSettings.excel}
                    onChange={(e) =>
                        setCoEditingSettings({
                            ...coEditingSettings,
                            excel: e.target.value as CoEditingSettings['excel'],
                        })
                    }
                >
                    <option>Start co-editing automatically</option>
                    <option>Ask the user</option>
                    <option>Open file without starting co-editing</option>
                </select>
            </div>

            <div className="setting-row">
                <label>Microsoft PowerPoint</label>
                <select
                    value={coEditingSettings.powerPoint}
                    onChange={(e) =>
                        setCoEditingSettings({
                            ...coEditingSettings,
                            powerPoint: e.target.value as CoEditingSettings['powerPoint'],
                        })
                    }
                >
                    <option>Start co-editing automatically</option>
                    <option>Ask the user</option>
                    <option>Open file without starting co-editing</option>
                </select>
            </div>

            <div className="ast-app-status-cspp-checkboxes__container mt-24 ms-office-desktop-modal-checkbox">
                <Checkbox
                    label="Allow users to overwrite these defaults"
                    key="Allow users to overwrite these defaults"
                    checked={coEditingSettings.allowOverwrite}
                    onChange={(value) =>
                        setCoEditingSettings({
                            ...coEditingSettings,
                            allowOverwrite: value,
                        })
                    }
                />
            </div>
        </div>

        <div className="version-note">
            <Icon alias="info" />
            Applicable for users who have Egnyte Desktop App for Windows v3.14.8 or Egnyte Desktop for Mac Core v0.7 or
            newer.
        </div>
    </div>
);
